export default {"src":"/_next/static/media/tomo.c8663472.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};